import { ElasticProduct } from "@usereactify/search";
import React from "react";

type ResultsItemTagProps = {
  product: ElasticProduct;
};
export const ResultsItemTag: React.FC<ResultsItemTagProps> = (props) => {
  // check if product has tag 'bestseller':
  const bestseller = props.product.tags?.find((tag) => tag === "bestsellers");
  // check if has 'stock':
  const stock = props.product.tags?.find((tag) => tag === "stock");

  const mb0: React.CSSProperties = {
    marginBottom: 0,
  };

  return (
    <>
      {bestseller && (
        <span className="w-fit product-grid-item-3__tag product-grid-item-3__tag--bestsellers" style={mb0}>
          Bestsellers
        </span>
      )}
      {stock && (
        <span className="w-fit product-grid-item-3__tag product-grid-item-3__tag" style={mb0}>
          In Stock
        </span>
      )}
    </>
  );
};
